/**
 * The public Orcaloops Privacy Policy, served at `orcaloops.ai/privacy`
 * (internally `/orca/privacy`).
 *
 * Reachable with NO session — `orca-public-paths.ts` lists `/orca/privacy` as a
 * public root, so the `/orca` layout guard returns before `requireAdmin`. That
 * is the whole point of the page: Google's OAuth "Publish app" review fetches
 * the privacy-policy URL anonymously on the authorized domain, and until it
 * resolves the Orcaloops app cannot leave Testing mode. Consequently this page
 * must never carry `robots: noindex`.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

import orcaDocCss from "~/components/orca/orca-doc.css?url";
import { OrcaPrivacyPage } from "~/components/orca/OrcaPrivacyPage.tsx";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * Head meta and sheets for the privacy policy (the v5 frame sheet, then the
 * reading-column sheet). Deliberately crawlable — no `robots`
 * directive, unlike the login door's `loginHead`.
 *
 * @since 1.0.0
 */
export const orcaPrivacyHead = () => ({
  meta: [
    { title: "Privacy Policy — Orcaloops" },
    { name: "description", content: "How Orcaloops collects, uses and protects your data." },
  ],
  links: [...orcaloopsStylesheetLinks, { rel: "stylesheet", href: orcaDocCss }],
});

export const Route = createFileRoute("/orca/privacy")({
  head: orcaPrivacyHead,
  component: OrcaPrivacyPage,
});
